import React from 'react';

export const BlockIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.594"
    height="17.594"
    viewBox="0 0 16.594 17.594"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M367.4,704.6a4.2,4.2,0,1,1,4.2-4.2A4.2,4.2,0,0,1,367.4,704.6Zm2.1-4.6h-4a0.5,0.5,0,0,0,0,1h4A0.5,0.5,0,0,0,369.5,700Zm-2.373-4.912A5.912,5.912,0,0,0,362.366,703L357,703c-1.663,0-2-.633-2-2,0-3.29,1.985-5.061,4.645-6.344a4.571,4.571,0,1,1,6.712,0A8.583,8.583,0,0,1,367.127,695.088Z"
      transform="translate(-355 -687)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/block-icon.js